import { BaseRepository } from './BaseRepository';
import { getDatabase, NexxusDatabase } from './NexxusDatabase';
import type { Facture } from '@shared/types/Facture';

export class FactureRepository extends BaseRepository<Facture> {
  constructor(db?: NexxusDatabase) {
    super((db ?? getDatabase()).factures);
  }
}
